exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".birthday-gift .birthday-gift-title svg[data-v-030bb1b0]{height:19px;fill:#1e824c}.birthday-gift .birthday-gift-content[data-v-030bb1b0]{margin-bottom:5px}.birthday-gift .btn[data-v-030bb1b0]{margin:0;width:114px}.birthday-gift .btn[data-v-030bb1b0]:hover{background:#1e824c;color:#fff}.birthday-gift .btn.loading span[data-v-030bb1b0]{display:none}.birthday-gift .birthday-success[data-v-030bb1b0]{font-weight:700}.birthday-gift .birthday-success svg[data-v-030bb1b0]{-webkit-margin-end:5px;-moz-margin-end:5px;margin-inline-end:5px;height:10px;fill:#1e824c}", ""]);

// exports
